import { Component, Input } from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Component({
  selector: 'app-radio-field',
  templateUrl: './radio-field.component.html',
  styleUrls: ['./radio-field.component.scss'],
})
export class RadioFieldComponent {
  @Input() id: string;
  @Input() label: string;
  @Input() name: string;
  @Input() control: AbstractControl;
  @Input() value: string | number | boolean;

  @Input() fakeControl: boolean;
  @Input() checked: boolean;
  @Input() readonly: boolean;

  constructor() {}
}
